import Box from '@mui/material/Box'
import InputLabel from '@mui/material/InputLabel'
import Typography from '@mui/material/Typography'
import { SelectHTMLAttributes } from 'react'
import { INPUT_MAX_WIDTH } from '../../../styles/muiTheme/GlobalStyles'

interface CustomProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string
  id?: string
  containerProps?: any
  children?: React.ReactNode
  placeholder?: string
}

const Select: React.FC<CustomProps> = ({
  label,
  id,
  containerProps,
  placeholder,
  children,
  ...props
}) => {
  return (
    <Box className="form-group mui-input" {...containerProps}>
      {label && (
        <InputLabel htmlFor={id}>
          <Typography variant="body_m_medium">{label}</Typography>
        </InputLabel>
      )}
      <select
        id={id}
        className="form-select"
        {...props}
        style={{
          maxWidth: INPUT_MAX_WIDTH,
        }}
      >
        <option value="" disabled selected hidden>
          {placeholder}
        </option>
        {children}
      </select>
    </Box>
  )
}

export default Select
